import { Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';

@Pipe({
    name: 'firestoreTimestamp',
    standalone: false
})
export class FirestoreTimestampPipe implements PipeTransform {
  transform(value: Timestamp): string {
    if (!value) return '';

    // Convert Firestore Timestamp to JavaScript Date object
    const date = value.toDate();

    // Format the date as you wish, here's an example using toLocaleTimeString()
    return date.toLocaleString();
  }
}
